import fetch from 'auth/FetchInterceptor'

const ActivityService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/activities', method: 'get', params }),
  get: (id) => fetch({ url: `/crm/activities/${id}`, method: 'get' }),
  create: (data) => fetch({ url: '/crm/activities', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/activities/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/activities/${id}`, method: 'delete' }),
}

export default ActivityService
